export const forgotPasswordResourcePath = "/forgot_password";
export const forgotPasswordResourceType = "forgot_password_request";
